import React, {useEffect, useState} from "react";
import {NavLink, useHistory} from "react-router-dom";
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  ListItem,
  Text, UnorderedList,
  useColorModeValue, usePrevious,
} from "@chakra-ui/react";
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustrationGL from "assets/img/auth/auth-gamelight.png";
import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import {useDispatch, useSelector} from "react-redux";
import {SignInAction, UpdateSignInRequestState} from "../../../listener/signin/action";
import {RootReducer} from "../../../RootReducer";

function Terms() {
  const dispatch = useDispatch();
  const history = useHistory();
  const signInRequestState = useSelector((state:RootReducer) => state.authentication.signInRequestState);
  const prevSignInRequestState = usePrevious(signInRequestState);

  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");

  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  const [mail, setMail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  useEffect(() => {
    return () => {
      dispatch(UpdateSignInRequestState({
        isFailed: false,
        isLoading: false,
        isSuccessful: false,
      }))
    }
  },[dispatch])

  useEffect(() => {
    if (localStorage.getItem('jwtToken')) {
      history.push('/ua')
    }
  }, [signInRequestState])

  useEffect(() => {
    const onEnter = (e: any) => {
      if (e.key === 'Enter') {
        dispatch(SignInAction(mail, password))
      }
    }

    window.addEventListener("keydown", onEnter);

    return () => {
      window.removeEventListener("keydown", onEnter);
    }
  }, [mail, password]);

  return (
    <DefaultAuth isSignIn={false} illustrationBackground={illustrationGL}>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w='100%'
        mx={{ base: "auto", lg: "-80px" }}
        me='auto'
        alignItems='start'
        justifyContent='center'
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "8vh" }}
        flexDirection='column'
      backgroundColor={'white'}>
        <Box me='auto' maxWidth={600}>
          <Heading color={textColor} fontSize='36px' mb='20px'>
            Terms of Use
          </Heading>
          <Text style={{ marginTop: 20}}>
            These Terms of Use (the “Terms”) is the legal agreement between you (the “User” or “you”) and Gamelight GmbH (“Gamelight”, “us” or “our” or “we” or “Company”) for your use of our website available at www.spotlightapps.io, and any of its subdomains (the “Site”).
          </Text>
          <Text style={{ marginTop: 20}}>
            BY ACCESSING AND/OR USING THE SITE, YOU ACKNOWLEDGE THAT YOU HAVE READ AND THAT YOU AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT CONNECT TO, ACCESS OR USE THE SITE IN ANY MANNER WHATSOEVER.
          </Text>
          <Text style={{ marginTop: 20}}>
            The Site is available only to individuals who (a) are at least eighteen (18) years old; and (b) possess the legal authority to enter into these Terms and to form a binding agreement under any applicable law.          </Text>
          <Text style={{ marginTop: 20}}>
            THE SITE. The Site provides you with information regarding Gamelight, including without limitation Gamelight products and services, and any other content available therein such as data, materials, contact information, designs and graphic user interface (collectively, the “Content”). In addition, the Site provides you the ability to contact us via the contact form (the “Contact Form”).          </Text>
          <Text style={{ marginTop: 20}}>
            TO THE EXTENT LEGALLY PERMISSIBLE ALL RIGHTS IN AND TO THE CONTENT AVAILABLE ON THE SITE ARE RESERVED TO Gamelight. TO THE EXTENT LEGALLY PERMISSIBLE, THE SITE AND THE CONTENT AVAILABLE THEREIN ARE PROVIDED ON AN “AS IS” BASIS. Gamelight WILL NOT BE LIABLE FOR ANY DAMAGES OR LOSS INCURRED BY YOU OR ANY OTHER PERSON AS A RESULT OF OR IN CONNECTION WITH YOUR USE OF THE SITE AND/OR THE CONTENT AVAILABLE THEREIN.
            YOUR USE OF THE SITE, AND/OR THE CONTENT AVAILABLE THEREIN IS ENTIRELY AT YOUR OWN RISK.
          </Text>
          <Text style={{ marginTop: 20}}>
            Terms:
          </Text>
          <UnorderedList>
            <ListItem>All KPIs, traffic requirements, and traffic restrictions will be clearly provided by the Advertiser before each campaign. If quality requirements and relevant event postbacks are not provided by the Advertisers, they will be responsible for all the traffic delivered. If the Advertiser provided quality requirements and relevant event postbacks, they will be responsible for payment unless traffic is proven to be fraudulent by providing legitimate reports from MMPs.</ListItem>
              <ListItem> All campaigns and activity between the Advertiser and Gamelight will be governed by IAB Standard Terms and Conditions Version 4a.
            https://www.iab.com/wp-content/uploads/2015/06/IAB_4As-tsandcs-FINAL.pdf</ListItem>
            <ListItem>This Agreement will be governed by the laws of Germany. Any claim arising with this Agreement shall be settled by the courts of Hamburg, Germany.</ListItem>
            <ListItem>Payment Terms: Invoice, Net 30 Date after the end of the billable month.</ListItem>
            <ListItem>Invoicing numbers will be confirmed latest until the 20th day of the following month. Any deductions must be explained and backed up by data and legitimate reports from an MMP by the Advertiser.</ListItem>
            <ListItem>Either Party may terminate this contract, for any or no reason, by giving the other Party a two (2) business days’ notice.</ListItem>
          </UnorderedList>
            <Text style={{ marginTop: 20}}>
            CONTACT US. If you have any questions, complaints and/or claims, you may contact us at partners@gamelight.io          </Text>
        </Box>
      </Flex>
    </DefaultAuth>
  );
}

export default Terms;
